'use client';

import React from 'react';
import { Chip } from '@heroui/react';
import { Typography } from '../../../../components';
import { useTranslations } from '../../../../contexts/translation.context';
import { RevshareCost } from '../types';

interface StatusCellProps {
  cost: RevshareCost;
}

const StatusCell: React.FC<StatusCellProps> = ({ cost }) => {
  const { t } = useTranslations();

  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'in_pending':
        return { dot: 'bg-warning', label: t('partner.revshare.costs.statusPending') };
      case 'paid':
        return { dot: 'bg-success', label: t('partner.revshare.costs.statusApproved') };
      default:
        return { dot: 'bg-gray-600', label: status };
    }
  };

  const statusConfig = getStatusConfig(cost.status);

  return (
    <Chip
      className="bg-gray-100 text-gray-900"
      classNames={{
        base: 'h-6 px-2 py-1 gap-1',
      }}
      size="sm"
      startContent={<div className={`w-2 h-2 rounded-full ${statusConfig.dot}`} />}
    >
      <Typography variant="body3" className="text-gray-900">
        {statusConfig.label}
      </Typography>
    </Chip>
  );
};

export default StatusCell;
